<div class="pdf-page app-aul-031-24" id="aul03124">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b>BURGLARY AND ROBBERY PROTECTIVE SAFEGUARDS</b>
  </p>
  <p class="font-large">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <p class="font-small mb-0">
    This endorsement modifies insurance provided under the following:
  </p>
  <p class="font-small">COMMERCIAL PROPERTY COVERAGE PART</p>
  <br />
  <p class="font-small mb-0" style="text-align: center"><b>SCHEDULE</b></p>
  <table
    class="font-small"
    style="border: 1px solid black; border-collapse: collapse; width: 100%"
  >
    <tbody>
      <tr>
        <th
          style="
            text-align: center;
            border: 1px solid black;
            padding: 5px;
            width: 25%;
          "
        >
          Premises No.
        </th>
        <th
          style="
            text-align: center;
            border: 1px solid black;
            padding: 5px;
            width: 25%;
          "
        >
          Bldg No.
        </th>
        <th
          style="
            text-align: center;
            border: 1px solid black;
            padding: 5px;
            width: 25%;
          "
        >
          Protective Safeguards Symbols Applicable
        </th>
      </tr>
      <tr>
        <td
          style="
            text-align: center;
            border: 1px solid black;
            padding: 5px;
            width: 25%;
          "
        >
          All Covered Premises as described in the Declarations
        </td>
        <td
          style="
            text-align: center;
            border: 1px solid black;
            padding: 5px;
            width: 25%;
          "
        >
          All Covered Buildings as described in the Declarations
        </td>
        <td
          style="
            text-align: center;
            border: 1px solid black;
            padding: 5px;
            width: 25%;
          "
        >
          "BR-4" All Protective Safeguards as described in Your submission
          and/or application
        </td>
      </tr>
      <tr style="border-top: 1px solid black">
        <td
          colspan="3"
          class="p-2"
          style="border: 1px solid black; padding: 5px"
        >
          <b
            >Additional requirements, if any, for engagement of an automatic
            burglary alarm or other automatic system listed in this Schedule
            (other than the requirements of Paragraph A.2.): NONE</b
          >
        </td>
      </tr>
    </tbody>
  </table>
  <br />
  <ol type="A" class="font-small">
    <!-- A -->
    <li>
      <p>The following is added to the: Commercial Property Conditions</p>
      <p><b>Burglary and Robbery Protective Safeguards </b></p>
      <p>As a condition of this insurance, you are required to:</p>
      <ol>
        <li>
          Maintain the protective safeguards listed in the Schedule, and over
          which you have control, in complete working order;
        </li>
        <li>
          Actively engage any automatic burglary alarm or other automatic system
          listed in the Schedule and maintain it in the “on” position during all
          non-work hours and whenever the premises are unoccupied;
        </li>
        <li>
          Actively engage any automatic burglary alarm or other automatic
          system, or parts thereof, in accordance with any requirements, if any,
          indicated in the Schedule; and
        </li>
        <li>
          Notify us if you know of any suspension of or impairment in any
          protective safeguard listed in the Schedule.
          <br />
          However, notification to us of the suspension o f or impairment in an
          automatic burglary alarm or other automatic system listed in the
          Schedule will not be necessary if you:
          <ol type="a">
            <li>
              Can restore full protection within 48 hours of the suspension or
              impairment;
            </li>
            <li>
              Provide at least one watchperson or other means of surveillance at
              the premises during all non-work hours and whenever the premises
              are otherwise unoccupied; and
            </li>
            <li>
              Provide at least one watchperson or other means of surveillance
              during work hours if the Schedule requires that the premises or
              part thereof be protected during work hours.
            </li>
          </ol>
        </li>
      </ol>
    </li>
  </ol>
</div>

<div class="pdf-page app-aul-031-24">
  <ol type="A" start="2" class="font-small">
    <!-- B -->
    <li>
      <p>
        The following is added to the EXCLUSIONS section of:<br />
        CAUSES OF LOSS - SPECIAL FORM
      </p>
      <p>
        We will not pay for loss or damage caused by or resulting from theft if,
        prior to the theft, you failed to comply with any condition set forth in
        Paragraph <b>A</b>.
      </p>
    </li>

    <!-- C -->
    <li>
      The protective safeguards to which this endorsement applies are identified
      by the following symbols or as described in Your submission and/or
      application:
      <ol>
        <li>
          <b>“BR-1” Automatic Burglary Alarm</b>, protecting the entire
          building, that signals to:
          <ol style="list-style-type: lower-alpha">
            <li>An outside central station; or;</li>
            <li>A police station;</li>
          </ol>
        </li>
        <li>
          <b>"BR-2" Automatic Burglary Alarm</b>, protecting the entire
          building, that has a loud sounding gong or siren on the outside of the
          building.
        </li>
        <li>
          <b>"BR-3" Security Service</b>, with a recording system or watch
          clock, making hourly rounds covering the entire building, when the
          premises are not in actual operation.
        </li>
        <li>
          <b>"BR-4"</b> The protective safeguard described in the Schedule.
        </li>
      </ol>
    </li>
  </ol>
</div>
